export function AboutLinks() {
  return (
    <div className="about-links">
      <a
        href="https://github.com/baditaflorin/cursorparty"
        target="_blank"
        rel="noreferrer"
        title="View source on GitHub"
      >
        ★ source
      </a>
      <a
        href="https://www.paypal.com/paypalme/florinbadita"
        target="_blank"
        rel="noreferrer"
        title="Support the maintainer"
      >
        ☕ donate
      </a>
    </div>
  );
}
